module.exports = __webpack_public_path__ + "shanz/static/media/EASTERN FEMALE banner.e941f3ee.png";